/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentHistoryExecutionTypeQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ComplianceAssessmentHistoryExecutionTypeQueryOperator");
    }

    getFixupPrototypeFunction() { return ComplianceAssessmentHistoryExecutionTypeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentHistoryExecutionTypeQueryOperator>): ComplianceAssessmentHistoryExecutionTypeQueryOperator {
        let obj = Object.assign(new ComplianceAssessmentHistoryExecutionTypeQueryOperator(), model);
        ComplianceAssessmentHistoryExecutionTypeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentHistoryExecutionTypeQueryOperator>): ComplianceAssessmentHistoryExecutionTypeQueryOperator {
        if (!model) return null;
        return ComplianceAssessmentHistoryExecutionTypeQueryOperator.newInstance(<ComplianceAssessmentHistoryExecutionTypeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentHistoryExecutionTypeQueryOperator) {
        if (!obj) return;

        models.ComplianceAssessmentHistoryExecutionTypeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentHistoryExecutionTypeQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ComplianceAssessmentHistoryExecutionTypeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Execution types to filter assessment history
     */
    execution_types: Array<models.AssessmentExecutionType>;

}
